<template>
	<page-container :page="page">
		<main-content
			:title="page.title || page.header"
			:title-right="page.titleRight"
			:subtitle="page.subtitle"
			:content="page.content"
			:intro-image="page.introImage"
			:intro-image-webp="page.introImageWebp"
			:intro-image-portrait="page.introImagePortrait"
			:intro-image-portrait-webp="page.introImagePortraitWebp"
		/>

		<section class="main-content contact-section background-dark">
			<div class="row">
				<div class="columns column6">
					<h2>{{ $t('contactFormHeader') }}</h2>
					<contact-form name="contact" :form="form" />
				</div>
				<div class="columns column6">
					<p>
						<strong>{{ defaults[locale].website.hotelName }}</strong>
						<br /><br />
						<span>{{ defaults[locale].website.street }} {{ defaults[locale].website.number }}</span>
						<br />
						<span>{{ defaults[locale].website.postalCode }} {{ defaults[locale].website.city }}</span>
						<br />
						<span>{{ defaults[locale].website.country }}</span>
						<br />
					</p>
					<social-media :socials="socials" />
					<iframe
						src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4769.517301961141!2d5.064616056635394!3d53.29385828106402!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c92b2625e9e883%3A0x81a3d5d8eb72726d!2sBoutiquehotel%20het%20Eiland!5e0!3m2!1sen!2snl!4v1717751026201!5m2!1sen!2snl"
						width="100%"
						height="400"
						frameborder="0"
						allowfullscreen
					/>
				</div>
			</div>
		</section>

		<contentblocks v-if="page.contentblocks && page.contentblocks.length" :items="page.contentblocks" />

		<review-slider v-if="page.showReviewSlider" :header="defaults[locale].website.reviewsHeader" />

		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>

		<newsletter
			v-if="page.showNewsletter"
			:header="defaults[locale].newsletter.title"
			:content="defaults[locale].newsletter.content"
			:button="defaults[locale].newsletter.button"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, socials, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();

const { data: form } = await useWebsiteFetch('contact', {
	query: { language: locale.value },
	key: `${locale.value}/contact`,
});
</script>

<style scoped lang="scss">
.error {
	color: red;
}

form {
	input,
	textarea,
	label,
	select {
		width: 100%;
		padding: 25px;
		margin: 5px 0;
		border: 1px solid #efefef;
	}

	input.button {
		width: auto;
	}

	label {
		padding: 25px 0 5px;
		display: block;
		border: none;
	}

	select {
		background-color: var(--primary-background-color);
		width: 100%;
	}
}

.checkbox-container {
	display: flex;
	margin: 5px 0 10px;

	label,
	input {
		width: auto;
		padding: 0;
		font-size: 0.9em;
	}

	label {
		margin: 0 5px 0 0;
	}

	input {
		margin: 5px 8px 0 0;
	}
}
</style>
